import { z } from "zod";

export const VersionsFormSchema = z.object({
    Title: z.string(),
    FileName: z.string(),
    ParentVersionID: z.string()
})

export const VersionsFormData = (data: z.infer<typeof VersionsFormSchema>) => {
    const formData = new FormData();
    formData.set('Title', data.Title);
    formData.set('ParentVersionID', data.ParentVersionID);
    formData.set('FileName', data.FileName);

    return formData;
}